import axios from 'axios';
import '../css/modalRecuperar.css';
import { handleError, toastError, toastSuccess } from '../funciones.js';
import FormInput from './FormInput.js';

function ModalRecuperar() {



    function cambiarContraseña() {

        var password = document.getElementById("contraseñaRecuperar").value;
        var passConfirm = document.getElementById("contraseñaConfirmarRecuperar").value;
        if (password !== passConfirm)
            toastError("Las contraseñas deben coincidir");
        else if (passConfirm === "") {
            toastError("Las contraseñas no pueden estar vacias");
        } else {
            var mail;
            if (localStorage.getItem(process.env.REACT_APP_MAIL_EMPRESA) !== null)
                mail = localStorage.getItem(process.env.REACT_APP_MAIL_EMPRESA);
            else
                mail = document.getElementById("mailRecuperar").value;

            const params = {
                mail: mail,
                password: password

            }
            axios.put(process.env.REACT_APP_URL + "empresa/cambiarPassword", params)
                .then(response => {
                    toastSuccess("Contraseña cambiada con éxito");
                    document.getElementById('cerrarModalRecuperar').click();
                    document.getElementById("contraseñaRecuperar").value = "";
                    document.getElementById("contraseñaConfirmarRecuperar").value = "";
                })
                .catch(function (error) {
                    toastError(handleError(error));
                });
        }

    }

    function cerrarModal() {
        if (parseInt(localStorage.getItem(process.env.REACT_APP_DESDE_PERFIL)) === 2) {
            localStorage.removeItem(process.env.REACT_APP_DESDE_PERFIL)
            document.getElementById('abrirPerfil').click();
        }

    }
    return (<>
        <div class="modal fade" id="ModalRecuperar" tabindex="-1" aria-labelledby="ModalRecuperarLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content padModalCodigo rounded-4">
                    <div class="modal-header">
                        <h5 class="letraTituloPerfil mb-0" id="ModalRecuperarLabel">Ingrese su nueva contraseña</h5>
                        <button type="button" class="btn-close ms-auto" id="cerrarModalRecuperar" aria-label="Close"
                            data-bs-dismiss="modal" onClick={cerrarModal}></button>
                    </div>
                    <div class="modal-body">
                        <div className='d-none' data-bs-toggle="modal" data-bs-target="#ModalRecuperar" id="abrirModalRecuperar"></div>
                        <FormInput id={"contraseñaRecuperar"} text={"Contraseña"} idSeccion={9} className={"py-2"}/>
                        <FormInput id={"contraseñaConfirmarRecuperar"} text={"Verifica tu contraseña"} idSeccion={9} className={""}/>
                        
                        <div className='text-center py-2'>
                            <button class="btn colorPrincipal text-white bold-botones mt-5 " type="submit" onClick={cambiarContraseña}>Cambiar</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
    );
}

export default ModalRecuperar;